import BasePolicy from '@/policies/BasePolicy.js';

export default class VideoPolicy extends BasePolicy {
    viewAny(user) {
        return user.hasPermissionTo('view all videos') || user.hasGroupPermissionTo('view all videos');
    }

    create(user) {
        if (user.hasGroupPermissionTo('create a video')) {
            return false;
        }

        return user.hasPermissionTo('create a video');
    }

    update(user, video) {
        if (user.hasGroupPermissionTo('edit a video')) {
            return user.isInAssetGroup(video);
        }

        return user.hasPermissionTo('edit a video');
    }

    delete(user) {
        if (user.hasGroupPermissionTo('delete a video')) {
            return false;
        }

        return user.hasPermissionTo('delete a video');
    }

    archive(user) {
        if (user.hasGroupPermissionTo('archive a video')) {
            return false;
        }

        return user.hasPermissionTo('archive a video');
    }
}
